import { Css, TagGroup, useTestIds } from "@homebound/beam";
import { useStepperContext } from "src/components/stepper";
import { ConfigureBidGroupsStepQuery } from "src/routes/bids/plan-based-bid-package/components/2.ConfigureBidGroupsStep.generated";
import { PlanBasedBidPackageStep } from "src/routes/bids/plan-based-bid-package/utils";

type HeaderSectionProps = { bidPackage: ConfigureBidGroupsStepQuery["bidPackage"] };

export function HeaderSection(props: HeaderSectionProps) {
  const { costCodes, costType, projects, productOfferings } = props.bidPackage;
  const { goToStep } = useStepperContext();
  const tid = useTestIds({});
  const costCodeNames = costCodes.map((cc) => cc.name).join(", ");
  return (
    <div css={Css.df.fdc.gap3.mb6.$}>
      <div css={Css.df.fdc.gap2.gray900.$}>
        <div css={Css.xl.$} {...tid.title}>
          Configure {costCodeNames} bid
        </div>
        <div css={Css.sm.$}>
          Configure how trades will bid the base scope and add-on options. Your selections create the cost lines in this
          bid.
        </div>
      </div>
      <div css={Css.df.fdc.gap1.$}>
        <div css={Css.df.aic.gap1.$} {...tid.summary}>
          <span css={Css.smSb.$}>{costCodeNames}</span>
          <span css={Css.xs.$}> | </span>
          <span css={Css.smSb.$}>{costType.name}</span>
          <span css={Css.xs.$}> | </span>
          <span css={Css.smSb.$}>{projects.map((p) => p.name).join(", ")}</span>
        </div>
        <div {...tid.productOfferings}>
          <TagGroup
            tags={productOfferings.map((pof) => ({ text: pof.name }))}
            onEdit={() => goToStep(PlanBasedBidPackageStep.DEFINE_PACKAGE)}
          />
        </div>
      </div>
    </div>
  );
}
